export default __webpack_public_path__ + "static/media/discord-logo.83dcc88f.svg";